import { useTranslation } from 'react-i18next';

import { ContactTabSectionHeading } from '~/scenes/PeopleModule/components/Tabs/ContactTab/components/ContactTabSectionHeading';
import { ContactTabSectionAccess } from '~/scenes/PeopleModule/components/Tabs/ContactTab/useContactTab';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { WorkContactEditMode } from './components/WorkContactEditMode';
import { WorkContactReadMode } from './components/WorkContactReadMode';
import { useWorkContact } from './useWorkContact';

export const WorkContact = (props: ContactTabSectionAccess) => {
  const { canEdit } = props;
  const { t } = useTranslation();

  const { form, actions, empData, readMode, companyOffice, isLoading } =
    useWorkContact();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <ContactTabSectionHeading
        heading={t('laWorkContact')}
        canEdit={canEdit}
        readMode={readMode}
        {...actions}
      />
      {readMode ? (
        <WorkContactReadMode data={empData} companyOffice={companyOffice} />
      ) : (
        <WorkContactEditMode form={form} companyOffice={companyOffice} />
      )}
    </>
  );
};
